export default {
  not_localised: 'Ten dokument nie jest jeszcze dostępny w Twoim regionie. Wyświetlamy wersję angielską.',
};
